import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { Input } from "Components/Input/Input";
import { Button } from "Components/Button/Button";
import { AuthUser } from "../../Services/login_service";
import { getPermisoRol } from "../../Services/permisos_service";
import { storageService } from "../../Services/storage_service";
import { setAuthUser } from "../../Slices/Login/loginSlice";
import { setPermisosAsignados } from "../../Slices/Permisos/permisosSlice";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { useNavigate } from "react-router-dom";

const adminLoginSchema = Yup.object({
  usuario: Yup.string().trim().required("El usuario es obligatorio"),
  password: Yup.string().trim().required("La contraseña es obligatoria"),
});

export const AdminLoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const formik = useFormik({
    initialValues: {
      usuario: "",
      password: "",
    },
    validationSchema: adminLoginSchema,
    onSubmit: async (values) => {
      await handleLogin(values);
    },
  });

  const handleLogin = async (values) => {
    setLoading(true);

    const loginData = {
      user: values.usuario,
      clave: values.password,
    };

    const resp = await AuthUser(loginData);

    if (Boolean(resp.result)) {
      dispatch(setAuthUser(resp.data[0]));
      storageService.setItem("user", resp.data[0]);

      const permisosRes = await getPermisoRol(resp.data[0]);
      dispatch(setPermisosAsignados(permisosRes));
      showSnackbar("Inicio de sesión exitoso", "success");

      setTimeout(() => {
        dispatch(setActiveDrawer(null));
        navigate(resp.data[0].ruta);
      }, 2000);
    } else {
      showSnackbar(resp.message, "error");
    }

    setLoading(false);
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      <Form
        onSubmit={formik.handleSubmit}
        noValidate
        className="admin-login__form"
      >
        <Input
          label="Usuario"
          name="usuario"
          id="usuario"
          type="text"
          placeholder="Ingresa tu usuario"
          value={formik.values.usuario}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={formik.touched.usuario && !!formik.errors.usuario}
          errorMessage={formik.touched.usuario ? formik.errors.usuario : ""}
          disabled={loading}
          autoComplete="username"
          autoFocus
        />

        <Input
          label="Contraseña"
          name="password"
          id="password"
          type="password"
          placeholder="Ingresa tu contraseña"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={formik.touched.password && !!formik.errors.password}
          errorMessage={formik.touched.password ? formik.errors.password : ""}
          disabled={loading}
          autoComplete="current-password"
        />

        <Button
          type="submit"
          disabled={
            loading ||
            !formik.values.usuario ||
            !formik.values.password ||
            !formik.isValid
          }
        >
          {loading && <CircularProgress size={20} sx={{ marginRight: 1 }} />}
          {loading ? "INICIANDO SESIÓN..." : "INICIAR SESIÓN"}
        </Button>
      </Form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};
